import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleUser,
  faIdCard,
  faArrowRightFromBracket,
  faNotesMedical,
  faUser,
  faSignOutAlt,
  faCrown
} from '@fortawesome/free-solid-svg-icons'; // o free-regular-icons si aplica


const Navbar = () => {
  const { user, logout } = useAuth();
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();
  const [scrolled, setScrolled] = useState(false);


  const isDoctor = user?.rol === 'doctor';
  const isAdmin = user?.rol === 'admin';
  const isPremium = user?.account_type === 'premium';

  const handleLogout = async () => {
    try {
      setLoadingLogout(true);
      await logout();
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    } finally {
      setLoadingLogout(false);
      setMenuOpen(false);
    }
  };

  // Cerrar menú si se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <nav
      className={`fixed top-0 left-0 w-full px-6 py-3 z-50 text-gray-800 transition-all duration-300 ${scrolled ? 'backdrop-blur-md bg-white/30 shadow-md' : ''
        }`}
    >

      <div className="max-w-7xl mx-auto flex items-center justify-between w-full">
        <Link to="/" className="flex items-center gap-2">
          <img src={process.env.PUBLIC_URL + "/assets/logonegro.png"} alt="Logo" className="h-12" />
        </Link>


        <div className="flex items-center gap-8 ml-auto">
          <div className="flex gap-6">
            {user ? (
              isAdmin ? (
                <Link to="/admin/dashboard" className="hover:text-gray-200">
                  Panel Admin
                </Link>
              ) : isDoctor ? (
                <>
                  <Link to="/doctor/home" className="hover:text-gray-200">Inicio</Link>
                  <Link to="/doctor/pacientes" className="hover:text-gray-200">Pacientes</Link>
                  <Link to="/doctor/citas" className="hover:text-gray-200">Citas</Link>
                </>
              ) : (
                <>
                  <Link to="/user/home" className="hover:text-black">Inicio</Link>
                  <Link to="/SignosVitales" className="hover:text-black">Signos vitales</Link>
                  <Link to="/Postura" className="hover:text-black">Postura</Link>
                  <Link to="/CitasUser" className="hover:text-black">Citas</Link>
                </>
              )
            ) : (
              <>
                <Link to="/quienes-somos" className="hover:text-black">¿Quiénes somos?</Link>
                <Link to="/productos" className="hover:text-black">Nuestros productos</Link>
                <Link to="/trabaja-con-nosotros" className="hover:text-black">¿Quieres trabajar con nosotros?</Link>
              </>
            )}
          </div>

          <div className="flex items-center gap-4 relative" ref={menuRef}>
            {user ? (
              <>
                {/* Botón Mi Perfil */}
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className={`px-6 py-2 rounded-full border transition duration-300 flex items-center gap-2 ${isPremium
                      ? 'border-transparent bg-gradient-to-r from-red-500 via-orange-500 to-amber-500  bg-clip-border text-white hover:bg-black hover:text-white'
                      : 'border-black text-black hover:bg-black hover:text-white'
                    }`}
                >
                  <FontAwesomeIcon icon={faCircleUser} />
                  {user.nombre}
                  <svg
                    className={`w-4 h-4 transition-transform ${menuOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {/* Menú desplegable */}
                {menuOpen && (
                  <div className="absolute left-0 top-full mt-2 bg-white text-black rounded shadow w-48 z-50">
                    <div className="px-4 py-2 border-b">Hola, <strong>{user.nombre}</strong></div>
                    <Link
                      to="/PerfilUser"
                      className="block px-4 py-2 hover:bg-gray-100 flex items-center gap-2"
                      onClick={() => setMenuOpen(false)}
                    >
                      <FontAwesomeIcon icon={faIdCard} />
                      Perfil
                    </Link>

                    {/* otra linea del menu desplegable
                  <Link
                    to="/pagos"
                    className="block px-4 py-2 hover:bg-gray-100 flex items-center gap-2"
                  >
                    Mis pagos
                    <FontAwesomeIcon icon={faCrown} />
                  </Link>
                  */}

                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-2"
                    >
                      <FontAwesomeIcon icon={faArrowRightFromBracket} />
                      Cerrar sesión
                    </button>
                  </div>
                )}

                {/* Botón Hazte Premium */}
                {user?.rol === 'user' && !isPremium && (
                  <Link
                    to="/suscripcion"
                    className="px-6 py-2 rounded-full bg-black text-white border-2 border-black hover:bg-transparent hover:text-black flex items-center gap-2 transition duration-300 italic"
                  >
                    Hazte Premium
                    <FontAwesomeIcon icon={faNotesMedical} />
                  </Link>
                )}


              </>
            ) : (
              <>
                <Link to="/login" className="px-6 py-2 border border-white text-white rounded-full hover:bg-white hover:text-black transition duration-300">
                  Iniciar sesión
                </Link>
                <Link to="/register" className="px-6 py-2 border border-white text-white rounded-full hover:bg-white hover:text-black transition duration-300">
                  Registrarse
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
